// React
import { useState } from 'react';

// Store
import useProfileStore from "../../../store/profileStore.js";

// Components 
import { Avatar, IconButton } from '@mui/material';
import { DeleteOutlined, EditOutlined, PersonOutline } from '@mui/icons-material';
import CustomBox from '../../custom/Box.js';

// Style
import { grey } from "@mui/material/colors/index.js";

function AvatarBox(props) {
    const { onDeleteProfilePicture, selectFile } = props;
    const { profilePicture } = useProfileStore();

    const [isHover, setHover] = useState(false);

    return (
      <CustomBox>
        { profilePicture ? (
			<Avatar 
				onMouseEnter={ () => setHover(true) } 
				onMouseLeave={ () => setHover(false) } 
				src={ !isHover ? URL.createObjectURL(profilePicture) : '' } 
				sx={{ 
					width: 180, 
					height: 180, 
					boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
					bgcolor: isHover ? 'rgb(0, 0, 0, 0.05)' : 'transparent',
					'@media (max-width: 900px)': {
						mr:5,
						width: 120,
						height: 120
					}
				}}
			>
					<IconButton sx={{ height: '100%', width: '50%', borderRadius: 0 }} onClick={selectFile}>
						<EditOutlined sx={{ width: 32, height: 32, color: grey[700] }} />
					</IconButton>

					<IconButton sx={{ height: '100%', width: '50%', borderRadius: 0 }} onClick={onDeleteProfilePicture}>
						<DeleteOutlined sx={{ width: 32, height: 32, color: grey[700] }} />
					</IconButton>
			</Avatar>

          ) : (

			<Avatar 
				onMouseEnter={ () => setHover(true)} 
				onMouseLeave={() => setHover(false) } 
				sx={{ 
					width: 180, 
					height: 180, 
					boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
					bgcolor: grey[500], 
					color: grey[100], 
					fontSize: '4rem',
					'@media (max-width: 900px)': {
						mr:5,
						width: 120,
						height: 120,
						fontSize: '2.5rem'
					}
				}}
			>
				{ isHover ? (
					<IconButton sx={{ height: '100%', width: '100%', borderRadius: 0 }} onClick={selectFile}>
						<EditOutlined sx={{ width: 32, height: 32, color: grey[200] }} />
					</IconButton>
				) : (
					<PersonOutline sx={{ fontSize: '8rem', '@media (max-width: 900px)': { fontSize: '3.5rem' } }} />
				)}
            </Avatar>
          )
        }
      </CustomBox>
    );
}

export default AvatarBox;